<template>
  <span v-if="isDisplayOnly">
    {{ selectedLeadStageName }}
  </span>
  <BLeadStageSelect
    v-else
    v-model="model"
    :lead-stages="leadStages"
    :required="required"
    fit
  />
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { LeadStage } from '@/api/openapi';
import { LeadStageApiService } from '@/api/user/resources/lead_stage';
import { useWait } from '@/composable/vue-wait';

type TProps = {
  required?: boolean;
  isDisplayOnly?: boolean;
  waitKeySuffix?: string;
};
const props = defineProps<TProps>();

const { doActionWithWait } = useWait();

const model = defineModel<number | null>();

const leadStages = ref<LeadStage[]>([]);
const loadLeadStages = async () => {
  await doActionWithWait(`fetchLeadStages${props.waitKeySuffix ?? ''}`, async () => {
    const api = new LeadStageApiService();
    const { data } = await api.getLeadStages();
    leadStages.value = data;
  });
};
loadLeadStages();

const selectedLeadStageName = computed(() =>
  leadStages.value.find(ls => ls.id === model.value)?.name ?? '',
);
</script>
